import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const NotFound = () => {
    const { t } = useTranslation();
    return (
        <Container className="not-found-wrapper d-flex flex-column mt-4 text-center" style={{ height: '100%' }} id="not-found">
            <p className="fs-2 fw-bold">{t("notFound.title")}</p>
            <div className="flex-grow-1"></div>
        </Container>
    );
};

export default NotFound;
